import '@styles/Banner/ConfirmacionDetalle.scss';
import { Text, CheckInput } from '@lana-ui/common';
import Beneficios from '../../Features/Beneficios';

const DetallesVentaBonificada = ({ email, setNewsletterChecked }) => {
    const handleCheckbox = (e) => {
        setNewsletterChecked(e.target.checked);
    };
    return (
        <>
            <Text className="confirmacion --twoxs">
                <div className="--mb-16">
                    Tu credencial Club LA NACION te brinda <strong>Acceso Digital</strong> <br />
                    sin cargo.
                </div>
                <Beneficios featuresBonificada={true} />
            </Text>
            <Text as="p" className="--alert --fourxs --mb-16">
                Recordá iniciar sesión con tu usuario <strong>{email}</strong> <br />
                para usar tu suscripción.
            </Text>
            <Text as="p" className="--terms --fourxs --mb-24">
                Al hacer click en Continuar, confirmo que he leído y aceptado los{' '}
                <a href="https://www.contacto.lanacion.com.ar/tyc" target="_blank" className="link --font-bold">
                    términos y condiciones.
                </a>
            </Text>
            <CheckInput
                className="checkbox --acepta-terminos"
                // error={formData.terminos !== '' && !checkTerminos}
                name="terminos"
                children={'Me gustaría recibir notas seleccionadas por la redacción en mi email.'}
                onChange={handleCheckbox}
            />
        </>
    );
};

export default DetallesVentaBonificada;
